import { render, staticRenderFns } from "./su1Results.vue?vue&type=template&id=22d8c772&scoped=true"
import script from "./su1Results.vue?vue&type=script&lang=js"
export * from "./su1Results.vue?vue&type=script&lang=js"
import style0 from "./su1Results.vue?vue&type=style&index=0&id=22d8c772&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d8c772",
  null
  
)

export default component.exports